import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import GlobalStyle from 'theme/GlobalStyle';
import store from '../redux/store';
import LandingView from './LandingView/LandingView';
import MercedesView from './MercedesView/MercedesView';
import QrView from './QrView/QrView';

const App = () => (
  <Provider store={store}>
    <GlobalStyle />
    <Router>
      <Switch>
        <Route exact path="/">
          <LandingView />
        </Route>
        <Route exact path="/mercedes">
          <MercedesView />
        </Route>
        <Route path="/qr/:code">
          <QrView />
        </Route>
      </Switch>
    </Router>
  </Provider>
);

export default App;
